import React, { useEffect, useState } from "react";
import * as images from "../../resources/images";
import { useForm } from "react-hook-form";
import Notification from "../footer/Notification";
import { NavLink, useNavigate } from "react-router-dom";
import { PATHS } from "../../utils";
import { useDispatch, useSelector } from "react-redux";
import { userSignup } from "../../redux/actions/Api";
import {
  EMAIL_REGEX,
  FNAME_REGEX,
  L_CHAR_REGEX,
  LNAME_CHAR_REGEX,
} from "../../utils/Regex";
import Loader from "../Loader";
import { resetLoginResponseFailure } from "../../redux/actions";
import ReactGA from "react-ga4";

const generateCaptcha = () => {
  const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789"; // no confusing chars
  let captcha = "";
  for (let i = 0; i < 6; i++) {
    captcha += chars[Math.floor(Math.random() * chars.length)];
  }
  return captcha;
};

const Signup = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    setError,
    clearErrors,
    watch,
    formState: { errors },
  } = useForm();

  const { signupresponse, signupResponseError } = useSelector(
    (state) => state.collections
  );

  const [loader, setLoader] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [passwordStrength, setPasswordStrength] = useState("");

  const [captcha, setCaptcha] = useState("");
  const [userCaptcha, setUserCaptcha] = useState("");
  const [captchaError, setCaptchaError] = useState("");

  const password = watch("password");
  const confirmPassword = watch("confirmPassword");

  // Generate captcha on mount
  useEffect(() => {
    setCaptcha(generateCaptcha());
  }, []);

  const refreshCaptcha = () => {
    setCaptcha(generateCaptcha());
    setUserCaptcha("");
    setCaptchaError("");
  };

  const validateCaptcha = () => {
 if (/[a-z]/.test(userCaptcha)) {
    setCaptchaError("Captcha must be entered in UPPERCASE letters.");
    return false;
  }
    if (userCaptcha !== captcha) {
      setCaptchaError("Invalid captcha, please try again");
      return false;
    }
    setCaptchaError("");
    return true;
  };

  useEffect(() => {
    eventTracker();
  }, []);

  const eventTracker = (
    category = "Signup",
    action = "APU action",
    label = "APU label"
  ) => {
    ReactGA.event({ category, action, label });
  };

  useEffect(() => {
    if (signupResponseError) {
      setTimeout(() => {
        setLoader(false);
      }, 200);
    }
  }, [signupResponseError]);

  const _onSubmit = (values) => {
    if (signupResponseError) {
      dispatch(resetLoginResponseFailure());
    }

     if (!validateCaptcha()) return;

 const emailAddress = values.useremail;
  if (
    emailAddress.includes("@apu.edu.in") ||
    emailAddress.includes("@azimpremjifoundation.org")
  ) {
    setError("useremail", {
      type: "custom",
      message:
        "Please note that the system does not accept Azim Premji foundation or APU email id. Kindly sign up with your personal email id. Provide your foundation email id in the alternate contact details asked for in the application form.",
    });
    return; // 🚫 stop form submission
  } else {
    clearErrors(["useremail"]);
  }

    let formData = {
      first_name: values.firstname,
      last_name: values.lastname,
      email: values.useremail,
      password: values.password,
      mobile: values.mobileNumber
    };

    if (formData) {
      setLoader(true);
      dispatch(userSignup(formData));
    }
  };

  useEffect(() => {
    if (signupresponse) {
      setTimeout(() => {
        setLoader(false);
       // navigate(PATHS.USERSIGNIN);
          navigate(PATHS.USERVERIFY);
      }, 1500);
    }
  }, [signupresponse]);

  const handleEmail = (e) => {
    let emailAddress = e.target.value;

    if (
      emailAddress.includes("@apu.edu.in") ||
      emailAddress.includes("@azimpremjifoundation.org")
    ) {
      setError("useremail", {
        type: "custom",
        message:
          "Please note that the system does not accept Azim Premji foundation or APU email id. Kindly sign up with your personal email id. Provide your foundation email id in the alternate contact details asked for in the application form.",
      });
    } else {
      clearErrors(["useremail"]);
    }
  };

  // Password strength checker
  const checkPasswordStrength = (value) => {
    const regexLower = /[a-z]/;
    const regexUpper = /[A-Z]/;
    const regexNumber = /[0-9]/;
    const regexSymbol = /[^A-Za-z0-9]/;

    let strength = 0;
    if (regexLower.test(value)) strength++;
    if (regexUpper.test(value)) strength++;
    if (regexNumber.test(value)) strength++;
    if (regexSymbol.test(value)) strength++;
    if (value.length >= 8) strength++;

    if (!value) return setPasswordStrength("");
    if (strength <= 2) setPasswordStrength("Weak");
    else if (strength === 3 || strength === 4) setPasswordStrength("Medium");
    else if (strength === 5) setPasswordStrength("Strong");
  };

  return (
    <div
      class="main_container"
      style={{
        backgroundImage: `url("https://apf-uat--uat.sandbox.my.site.com/admissions/file-asset/univ_building_8_reduced_image?v=1")`,
        width: "100%",
        height: "100%",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div class="container_box min_hgt_100">
        <div class="header">
          <img src={images.apuLogo1} />
        </div>
        <Loader show={loader} />
        <form
          name="signup"
          onSubmit={handleSubmit(_onSubmit)}
          onFocus={(e) => e.target.setAttribute("autoComplete", "none")}
        >
          <div class="signup_box">
            {signupResponseError && (
              <p className="error_shown">{signupResponseError}</p>
            )}
            <div class="input_box">
              <label>
                First Name <span>*</span>
              </label>
              <input
                type="text"
                id="fname"
                {...register("firstname", {
                  required: {
                    value: true,
                    message: "First name is required",
                  },
                  pattern: {
                    value: LNAME_CHAR_REGEX,
                    message: "Only characters allowed",
                  },
                })}
              />
              <div className="error_shown">{errors.firstname?.message}</div>
            </div>
            <div class="input_box">
              <label>
                Last Name <span>*</span>
              </label>
              <input
                type="text"
                id="lname"
                {...register("lastname", {
                  required: {
                    value: true,
                    message: "Last name is required",
                  },
                  pattern: {
                    value: LNAME_CHAR_REGEX,
                    message: "Only characters allowed",
                  },
                })}
              />
              <div className="error_shown">{errors.lastname?.message}</div>
            </div>
            
            <div class="input_box">
              <label>
                Email <span>*</span>
              </label>
              <input
                type="text"
                {...register("useremail", {
                  required: {
                    value: true,
                    message: "Email is required",
                  },
                  pattern: {
                    value: EMAIL_REGEX,
                    message: "Please enter a correct Email Address",
                  },
                })}
                id="email"
                onChange={handleEmail}
              />
              <div className="error_shown">{errors.useremail?.message}</div>
            </div>
            {/* mobile */}
             <div className="input_box">
  <label>
    Mobile Number <span>*</span>
  </label>
  <input
    type="text"
    {...register("mobileNumber", {
      required: {
        value: true,
        message: "Mobile number is required",
      },
      pattern: {
        value: /^[0-9]{10}$/, // only numbers, exactly 10 digits
        message: "Please enter a valid 10-digit mobile number",
      },
      maxLength: {
        value: 10,
        message: "Mobile number cannot exceed 10 digits",
      },
    })}
    id="mobileNumber"
    maxLength={10} // 
    onInput={(e) => {
      e.currentTarget.value = e.currentTarget.value.replace(/[^0-9]/g, ""); // remove non-numeric input
    }}
  />
  <div className="error_shown">{errors.mobileNumber?.message}</div>
</div>
            {/* Password */}
            <div className="input_box">
              <label>
                New Password <span>*</span>
              </label>
              <div
                className="password-wrapper"
                style={{ position: "relative" }}
              >
                <input
                  type={showPassword ? "text" : "password"}
                  {...register("password", {
                    required: "Password is required",
                    validate: (value) => {
                      const regex =
                        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;
                      return (
                        regex.test(value) ||
                        "Password must be 8 chars with 1 uppercase, lowercase, number & symbol"
                      );
                    },
                  })}
                  onChange={(e) => checkPasswordStrength(e.target.value)}
                  style={{
                    width: "100%", // keeps input inside the box
                    paddingRight: "130px", // just extra space inside the field
                    boxSizing: "border-box", // prevents overflow
                  }}
                />
                {/* Password strength text inside input */}
                {passwordStrength && (
                  <span
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      fontWeight: "500",
                      fontSize: "13px",
                      color:
                        passwordStrength === "Weak"
                          ? "red"
                          : passwordStrength === "Medium"
                          ? "orange"
                          : "green",
                    }}
                  >
                    {passwordStrength}
                  </span>
                )}

                {/* <span
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                  }}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </span> */}
              </div>
              <div className="error_shown">{errors.password?.message}</div>

              {/* Password strength message */}
              {/* {passwordStrength && (
                <div
                  style={{
                    marginTop: "4px",
                    fontWeight: "500",
                    color:
                      passwordStrength === "Weak"
                        ? "red"
                        : passwordStrength === "Medium"
                        ? "orange"
                        : "green",
                  }}
                >
                  Password strength: {passwordStrength}
                </div>
              )} */}
            </div>

            {/* Confirm Password */}
            <div className="input_box">
              <label>
                Confirm Password <span>*</span>
              </label>
              <div
                className="password-wrapper"
                style={{ position: "relative" }}
              >
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  {...register("confirmPassword", {
                    required: "Confirm Password is required",
                    validate: (value) =>
                      value === password || "Password do not match",
                  })}
                  style={{
                    width: "100%",
                    paddingRight: "100px", // reserve space for Match text
                    boxSizing: "border-box",
                  }}
                />
                {/* ✅ Match / Not Match indicator */}
                {confirmPassword && (
                  <span
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      fontWeight: "500",
                      fontSize: "13px",
                      color: confirmPassword === password ? "green" : "red",
                    }}
                  >
                    {confirmPassword === password && "Match"}
                  </span>
                )}
                {/* <span
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                  }}
                >
                  {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                </span> */}
              </div>
              <div className="error_shown">
                {errors.confirmPassword?.message}
              </div>
            </div>

            {/* Captcha appears only when passwords match */}
                <div className="input_box">
                  <label>Enter Captcha *</label>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <div
                      style={{
                        flex: 1, // ✅ stretch horizontally
                        background: "#fff",
                        fontWeight: "bold",
                        fontSize: "18px",
                        letterSpacing: "3px",
                        userSelect: "none",
                        borderRadius: "4px",
                        border: "1px solid #ccc",
                        height: "42px", // ✅ same height as Confirm Password
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        boxSizing: "border-box",
                      }}
                    >
                      {captcha}
                    </div>
                    <button
                      type="button"
                      onClick={refreshCaptcha}
                      style={{
                         width: "42px",          // same height as inputs
        height: "42px",
        padding: 0,             // remove internal padding so height is exact
        margin: 0,              // remove any default margin
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: "1px solid #ccc",
        background: "#f9f9f9",
        borderRadius: "4px",
        cursor: "pointer",
        boxSizing: "border-box",
        lineHeight: "normal",   // prevent baseline shifting
        verticalAlign: "middle",
                      }}
                    >
                      🔄
                    </button>
                  </div>
                  <input
                    type="text"
                    value={userCaptcha}
                    onChange={(e) => setUserCaptcha(e.target.value)}
                    placeholder="Type the captcha above"
                    maxLength={"6"}
                    style={{
                      marginTop: "8px",
                      height: "42px", // 👈 match other inputs
                      fontSize: "16px",
                      padding: "0 12px",
                      width: "100%",
      boxSizing: "border-box",
                    }}
                  />
                  {captchaError && (
                    <div className="error_shown">{captchaError}</div>
                  )}
                </div>
             
            <div class="input_box">
              <button type="submit" class="button_styl">
                Sign Up
              </button>
            </div>
            <div class="input_box">
              <p>
                Already Signed Up?{" "}
                <NavLink
                  to={PATHS.USERSIGNIN}
                  style={{ textDecoration: "none" }}
                >
                  Login Here
                </NavLink>
              </p>
            </div>
          </div>
        </form>
        <Notification />
      </div>
    </div>
  );
};

export default Signup;
